import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { getTestimonials } from "@/lib/testimonials";

export const Testimonials = ({ className = "" }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { getTestimonials().then(setItems).catch(() => setItems([])); }, []);
  if (!items.length) return null;
  return (
    <section className={`pp-testimonials ${className}`} data-testid="testimonials">
      <p className="pp-label">What parents say</p>
      <ul className="grid gap-3 mt-2">
        {items.slice(0, 3).map((t) => (
          <li key={t.id} className="pp-card pp-testimonial" data-testid={`testimonial-${t.id}`}>
            <Quote className="h-5 w-5 opacity-40" />
            <p className="mt-1">“{t.quote}”</p>
            <p className="text-sm font-bold mt-2" style={{ color: "var(--heading)" }}>— {t.display_name}</p>
          </li>
        ))}
      </ul>
    </section>
  );
};
